import script from "./ComponentUpload.vue?vue&type=script&setup=true&lang=js"
export * from "./ComponentUpload.vue?vue&type=script&setup=true&lang=js"

import "./ComponentUpload.vue?vue&type=style&index=0&id=101f1278&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-101f1278"]])

export default __exports__